import React from "react";
import { Redirect } from "react-router-dom";
import { Mutation } from "react-apollo";
import { CREATE_REGION_MANAGER } from "../../../graphql";
import Button from "../../UI/Button";
import RegionSelect from "../Select/Container";
import UserSelect from "../../User/Select/Container";

import {
  Rowz,
  Spacer
} from "../../../components/Layout/Layout";

class AssignManagerForm extends React.Component {
  state = {
    regionID: "",
    managerID: ""
  };

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  
  render() {
    return (
      <Mutation mutation={CREATE_REGION_MANAGER}>
        {(createRegionManager, { data, loading, called, error }) => {
          if (called && !error && !loading) {
            if (data.assignManagerToRegion) {
              return (
                <Redirect
                  to={{
                    pathname: "/",
                    state: {
                      message: `Manager assigned to region successfully`
                    }
                  }}
                />
              );
            }
          }

          return (
            <React.Fragment>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  createRegionManager({ variables: this.state });
                }}
              >
                <Spacer>
                  <Spacer>
                    <Rowz>
                      <RegionSelect required value={this.state.regionID} onChange={value=>this.handleInputChange("regionID",value)}/>
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <UserSelect required value={this.state.managerID} filterRole="MANAGER" onChange={value => this.handleInputChange("managerID", value)} />
                    </Rowz>
                  </Spacer>

                  <Spacer>
                    <Button type="submit" disabled={loading}>
                      Submit
                    </Button>
                  </Spacer>
                </Spacer>
              </form>
            </React.Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default AssignManagerForm;